import * as S from "./AuthTemplate.style";
import { ReactComponent as LogoCoastguard } from "../../../styles/assets/svg/logo_coastguard.svg";

interface AuthTemplateProps {
  children: React.ReactElement;
}

export const AuthTemplate = ({ children }: AuthTemplateProps) => {
  return (
    <S.AuthTemplate>
      <S.AuthTitleSection>
        <S.AuthTitleBg />
        <S.AuthTitleBox>
          함정 상태기반 정비 지원체계
          <span>
            Korea Coast Guard Ship Condition Based Maintenance Service System
          </span>
        </S.AuthTitleBox>
      </S.AuthTitleSection>

      <S.AuthInputSection>
        {children}

        <S.AuthLogoBox>
          <LogoCoastguard height={50} viewBox="0 0 255 73" />
        </S.AuthLogoBox>
      </S.AuthInputSection>
    </S.AuthTemplate>
  );
};
